import $ from 'jquery'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import './top/preloading'
import Modal from './modal'
import youtubeBackground from './top/youtube-background'
import animateMainvisual from './top/mainvisual'
import animateMission from './top/mission'
import animateSolution from './top/solution'
import animateCases from './top/cases'

gsap.registerPlugin(ScrollTrigger)

const scrolToMission = () => {
  $('body, html')
    .stop()
    .animate(
      {
        scrollTop: $('#mission').offset().top,
      },
      400,
      'swing'
    )
}

const onScrollClick = () => {
  $('.js-scroll-main').on('click', () => {
    scrolToMission()
  })
}

const Top = () => {
  if ($('#top').length !== 0) {
    onScrollClick()
    youtubeBackground()

    const modal = new Modal({ target: '.js-top-modal' })
    modal.init()

    animateMainvisual()
    animateMission()
    animateSolution()
    animateCases()
  }
}

export default Top
